import { Song } from '@/core/db.ts';

export function songName(song: Song) {
  return [song.artist, song.title].filter((s) => !!s).join(' - ');
}
